import * as actions from './util'

const gtag = {
  ...actions,
}

export { gtag }
